import { LayoutHeader } from "@/Header";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { CalendarNew as CalendarComponent } from "@/CalendarNew";
import { SwiperXBox } from "@/SwiperX";
// import { Button } from "@/Button";
import useCalendar from "^/customer/calendar";
import { useEffect, useState } from "react";
import { useLoadingStore } from "../../../stores/loading";
import { Button } from "@/Button";
export const Route = createFileRoute("/customer/layout/calendar")({
  component: Calendar,
});

function Calendar() {
  const { history } = useRouter();

  const {
    petList,
    // selectedPetSeq,
    handleSelectPet,
    handleSelectDate,
    calendarList,
    // calendarProductCount,
    handleSelectDay,
    // selectDate,
    selectedDay,
    isLoading,
    isFetching,
  } = useCalendar();
  // console.log(selectedDay, selectDate, selectedPetSeq);
  // 로딩 스토어 사용
  const { toggleLoading } = useLoadingStore();
  const [IsDoReservation, setIsDoReservation] = useState(false);

  // React Query 로딩 상태와 로딩 스토어 연동
  useEffect(() => {
    toggleLoading(isLoading || isFetching);
  }, [isLoading, isFetching, toggleLoading]);

  useEffect(() => {
    if (selectedDay) {
      // 오늘 날짜 가져오기
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 시간을 00:00:00으로 설정

      // selectedDay를 Date 객체로 변환
      const selectedDate = new Date(selectedDay);
      selectedDate.setHours(0, 0, 0, 0); // 시간을 00:00:00으로 설정

      // 다음날 계산 (오늘 + 1일)
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      // selectedDay가 다음날 이후인지 확인
      if (selectedDate >= tomorrow) {
        setIsDoReservation(true);
      } else {
        setIsDoReservation(false);
      }
    } else {
      setIsDoReservation(false);
    }
  }, [selectedDay]);
  const handleReservationChange = (type: string) => {
    let buttonName = "";
    if (type === "RESERV_STATUS_REQUESTED") {
      buttonName = "승인대기";
    } else if (type === "RESERV_STATUS_CONFIRMED") {
      buttonName = "예약완료";
    } else if (type === "RESERV_STATUS_CANCELED") {
      buttonName = "예약취소";
    } else if (type === "RESERV_STATUS_COMPLETED") {
      buttonName = "예약확정";
    } else if (type === "RESERV_STATUS_TEMP") {
      buttonName = "임시저장";
    }
    return buttonName;
  };

  const hanRevType = (type: string) => {
    let revType = "";
    if (type === "RESERV_TYPE_CLASS") {
      revType = "수업예약";
    } else if (type === "RESERV_TYPE_DAYCARE") {
      revType = "데이케어";
    } else if (type === "RESERV_TYPE_GROOMING") {
      revType = "미용 서비스";
    } else if (type === "RESERV_TYPE_HOTEL") {
      revType = "호텔 서비스";
    }
    // console.log(revType);
    return revType;
  };
  // console.log(petList);
  // console.log(selectedDay);
  return (
    <>
      <LayoutHeader title={"캘린더"} hasBackBtn={false} hasFootPrint={false} />
      {/* 수신자 */}
      <div className="flex flex-col flex-auto">
        <div className="flex-col flex-auto gap-1 px-4 pb-[calc(5rem+env(safe-area-inset-bottom,0px))] bg-[#F5F5F5] grid grid-cols-1">
          <div className="my-5">
            <SwiperXBox data={petList ?? []} handleSelect={handleSelectPet} />
            <CalendarComponent
              disabled={false}
              dayOnClick={(day) => {
                handleSelectDay(day);
              }}
              handleSelectDate={handleSelectDate}
              selectedDay={selectedDay}
              schedules={calendarList?.calendar ?? {}}
            />
            {IsDoReservation && (
              <Button
                className="mt-3 w-full bg-[#F5F5F5]"
                style={{ pointerEvents: "auto" }}
                onClick={() => history.push("/customer/layout/map")}
              >
                <div className="py-3 w-full text-base font-semibold text-center text-white bg-orange-400 rounded-full">
                  주변 매장 찾기
                </div>
              </Button>
            )}
            <div className="flex flex-col gap-4 mt-3">
              {calendarList?.props[0]?.datas
                .filter(
                  (item: { cdReservStatus: string }) =>
                    item.cdReservStatus !== "RESERV_STATUS_TEMP"
                )
                .map(
                  (item: {
                    reservationDetailSeq: number;
                    companyName: string;
                    cdReservType: string;
                    date: string;
                    cdReservStatus: string;
                    reservationSeq: string;
                  }) => (
                    <div
                      key={item.reservationDetailSeq}
                      className="flex justify-between items-center p-3 w-full bg-white rounded-xl sm:p-4"
                    >
                      <div className="min-w-0">
                        <div className="text-base font-medium truncate sm:text-lg">
                          {item.companyName}
                        </div>
                        <div className="text-sm text-[#757575] mt-1 truncate">
                          {hanRevType(item.cdReservType)}
                        </div>
                        <div className="text-xs text-[#BDBDBD] mt-1">
                          {item.date}
                        </div>
                      </div>
                      <div className="flex-shrink-0 ml-4">
                        <StatusButton
                          type={
                            item.cdReservStatus as
                              | "RESERV_STATUS_REQUESTED"
                              | "RESERV_STATUS_CONFIRMED"
                              | "RESERV_STATUS_CANCELED"
                              | "outline"
                          }
                          // 취소된 예약도 상세(취소 전 날짜·시간)를 볼 수 있게 이동 허용
                          onClick={() => {
                            history.push(
                              `/customer/layout/calendar-reservation-chg?cdReservStatus=${item.cdReservStatus}&cdReservType=${item.cdReservType}&reservationSeq=${item.reservationSeq}&reservationDetailSeq=${item.reservationDetailSeq}&companyName=${item.companyName}`
                            );
                          }}
                        >
                          {handleReservationChange(item.cdReservStatus)}
                        </StatusButton>
                      </div>
                    </div>
                  )
                )}

              {/* <div className="flex justify-between items-center p-3 w-full bg-white rounded-xl sm:p-4">
                <div className="min-w-0">
                  <div className="text-base font-medium truncate sm:text-lg">
                    아무개 강아지 유치원
                  </div>
                  <div className="text-sm text-[#757575] mt-1 truncate">
                    유치원 등원&nbsp;&nbsp;|&nbsp;&nbsp;희동이반
                  </div>
                  <div className="text-xs text-[#BDBDBD] mt-1">
                    10:00 ~ 17:00
                  </div>
                </div>
                <div className="flex-shrink-0 ml-4">
                  <StatusButton type="primary">예약변경</StatusButton>
                </div>
              </div>
              <div className="flex justify-between items-center p-3 w-full bg-white rounded-xl sm:p-4">
                <div className="min-w-0">
                  <div className="text-base font-medium truncate sm:text-lg">
                    아무개 강아지 유치원
                  </div>
                  <div className="text-sm text-[#757575] mt-1 truncate">
                    유치원 등원&nbsp;&nbsp;|&nbsp;&nbsp;희동이반
                  </div>
                  <div className="text-xs text-[#BDBDBD] mt-1">
                    10:00 ~ 17:00
                  </div>
                </div>
                <div className="flex-shrink-0 ml-4">
                  <StatusButton type="disabled">예약확정</StatusButton>
                </div>
              </div>
              <div className="flex justify-between items-center p-3 w-full bg-white rounded-xl sm:p-4">
                <div className="min-w-0">
                  <div className="text-base font-medium truncate sm:text-lg">
                    아무개 강아지 유치원
                  </div>
                  <div className="text-sm text-[#757575] mt-1 truncate">
                    유치원 등원&nbsp;&nbsp;|&nbsp;&nbsp;희동이반
                  </div>
                  <div className="text-xs text-[#BDBDBD] mt-1">
                    10:00 ~ 17:00
                  </div>
                </div>
                <div className="flex-shrink-0 ml-4">
                  <StatusButton type="outline">알림장</StatusButton>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

interface StatusButtonProps {
  children: React.ReactNode;
  type?:
    | "RESERV_STATUS_REQUESTED"
    | "RESERV_STATUS_CONFIRMED"
    | "RESERV_STATUS_CANCELED"
    | "RESERV_STATUS_COMPLETED"
    | "outline";
  onClick?: () => void;
}

const StatusButton = ({
  children,
  type = "outline",
  onClick,
}: StatusButtonProps) => {
  const base =
    "px-4 py-1.5 rounded-full text-sm font-medium min-w-[72px] text-center transition whitespace-nowrap";
  let style = "";

  if (
    type === "RESERV_STATUS_REQUESTED" ||
    type === "RESERV_STATUS_CONFIRMED"
  ) {
    style =
      "border border-[#FF9934] text-[#FF9934] bg-white hover:bg-[#FFF7ED]";
  } else if (type === "RESERV_STATUS_CANCELED") {
    // 취소 상태 — 회색 톤은 유지하되 상세 열람은 가능하므로 클릭 가능
    style =
      "bg-[#E9E9E9] text-[#757575] border border-[#E9E9E9] hover:bg-[#DEDEDE]";
  } else if (type === "outline") {
    style =
      "border border-[#BDBDBD] text-[#757575] bg-white hover:bg-[#F5F5F5]";
  }

  return (
    <button
      className={`${base} ${style} sm:px-5 sm:py-2 sm:text-base md:min-w-[90px] md:text-base`}
      onClick={onClick}
      disabled={type === "RESERV_STATUS_COMPLETED"}
    >
      {children}
    </button>
  );
};
